import React from "react";

interface CustomCommentProps {
  author: React.ReactNode;
  avatar: React.ReactNode;
  content?: React.ReactNode;
  datetime?: React.ReactNode;
}

const CustomComment: React.FC<CustomCommentProps> = ({
  author,
  avatar,
  content,
  datetime,
}) => {
  return (
    <div className="custom-comment" style={{ display: "flex", marginBottom: 16 }}>
      <div className="custom-comment-avatar" style={{ marginRight: 12 }}>
        {avatar}
      </div>
      <div className="custom-comment-content" style={{ flex: 1 }}>
        <div className="custom-comment-author" style={{ fontWeight: "bold" }}>
          {author}
        </div>
        {datetime && (
          <div className="custom-comment-datetime" style={{ fontSize: 12, color: "#999" }}>
            {datetime}
          </div>
        )}
        <div className="custom-comment-text" style={{ marginTop: 4 }}>
          {content}
        </div>
      </div>
    </div>
  );
};

export default CustomComment;
